import React from 'react';
import I18n from '~/utils/translations';
import { formatPence } from 'components/utils/currency.js';

export default class ListingPrice extends React.Component {
  constructor(props) {
    super(props);
    this.listing = this.props.listing;
  }

  get unavailable() {
    return I18n.t('home_points.unavailable');
  }

  render() {
    const periodSuffix = 'pm';
    const price = this.formattedPriceOption();
    const { furnishing, locale } = this.listing;

    return (
      <div className="home-tile__price-options">
        <div className="home-tile__price-option">
          <p className="home-tile__price-option-header">{I18n.t(`pages.homes.price_preferences.${furnishing}`)}</p>
          <p className={`home-tile__header-price home-tile__header-price--${furnishing}`}>
            {price}
            {locale == 'london' && price !== this.unavailable && <span className="home-price">{periodSuffix}</span>}
          </p>
        </div>
      </div>
    );
  }

  formattedPriceOption = () => {
    const { priceInPence, currency } = this.listing;

    if (!priceInPence) {
      return this.unavailable;
    } else {
      return formatPence(priceInPence, currency);
    }
  };
}
